import * as types from "./types";

export default {
  [types.MUTATE_CONSULTANTS_SEARCH_RESULT]: (state, payload) => {
    state.searchResult = payload;
  },
  [types.MUTATE_DNA_HISTORICAL_SEARCH_RESULT]: (state, payload) => {
    state.searchResultDnaHistorical = payload;
  },
  [types.MUTATE_IMPORTS_SEARCH_RESULT]: (state, payload) => {
    state.searchResultImports = payload;
  },
  [types.MUTATE_IMPORT_HISTORY_SEARCH_RESULT]: (state, payload) => {
    state.searchResultImportHistory = payload;
  },
  [types.CLEAR_DETAILS_GENERAL_INFORMATION]: (state, payload) => {
    state.details.generalInformation = undefined;
  },
  [types.MUTATE_DETAILS_GENERAL_INFORMATION]: (state, payload) => {
    state.details.generalInformation = payload;
  },
  [types.MUTATE_DETAILS_COMPANY_DATA]: (state, payload) => {
    state.details.companyData = payload;
  },
  [types.MUTATE_DETAILS_NETWORK_DATA]: (state, payload) => {
    state.details.networkData = payload;
  },
  [types.MUTATE_DIRECT_TEAM]: (state, payload) => {
    state.details.directTeam = payload;
  },
  [types.MUTATE_NEW_CONSULTANT_SIDEBAR]: (state, payload) => {
    state.newConsultantSidebar = { ...state.newConsultantSidebar, ...payload };
  },
  [types.MUTATE_NEW_EMPLOYEE_SIDEBAR]: (state, payload) => {
    state.newEmployeeSidebar = { ...state.newEmployeeSidebar, ...payload };
  },
  [types.MUTATE_TRANSFERRED_CONSULTANTS]: (state, payload) => {
    state.transferredConsultants = payload;
  },
  [types.MUTATE_TRANSFERABLE_CONSULTANTS]: (state, payload) => {
    state.transferableConsultants = payload;
  },
  [types.MUTATE_CHANGE_CONSULTANT_ROLE_SIDEBAR]: (state, payload) => {
    state.changeConsultantRoleSidebar = {
      ...state.changeConsultantRoleSidebar,
      ...payload,
    };
  },
  [types.MUTATE_CHANGE_PHYSICAL_FRANCHISE_SIDEBAR]: (state, payload) => {
    state.changePhysicalFranchiseSidebar = {
      ...state.changePhysicalFranchiseSidebar,
      ...payload,
    };
  },
  [types.MUTATE_AFFILIATION_TYPES]: (state, payload) => {
    state.affiliationTypes = payload;
  },
  [types.MUTATE_IMPORT_EAD_SIDEBAR]: (state, payload) => {
    state.importEadSidebar = { ...state.importEadSidebar, ...payload };
  },
  [types.MUTATE_PENDING_PROMOTION_STEPS]: (state, payload) => {
    state.pendingPromotionSteps = payload;
  },
  [types.MUTATE_DETAILS_INDICATORS_SUMMARY]: (state, payload) => {
    state.indicatorsSummary = payload;
  },
  [types.MUTATE_DETAILS_APPOINTMENT_CLOSURE_RATES]: (state, payload) => {
    state.appointmentClosureRates = payload;
  },
  [types.MUTATE_DETAILS_QUALITATIVE_HIGHLIGHTS]: (state, payload) => {
    state.qualitativeHighlights = payload;
  },
  [types.MUTATE_CONSULTANT_CERTIFICATE_SIDEBAR]: (state, payload) => {
    state.consultantCertificateSidebar = {
      ...state.consultantCertificateSidebar,
      ...payload,
    };
  },
  [types.MUTATE_CONSULTANT_CERTIFICATE_TYPES](state, payload) {
    state.certificateTypes = payload;
  },
  [types.MUTATE_CONSULTANT_TERMINATION_REASONS](state, payload) {
    state.consultantTerminationReasons = payload;
  },
  [types.MUTATE_PROMOTION_CONTRACT_RULES]: (state, payload) => {
    state.promotionContractRules = payload;
  },
  [types.MUTATE_ROLE_PROMOTION_SIDEBAR]: (state, payload) => {
    state.rolePromotionSidebar = { ...state.rolePromotionSidebar, ...payload };
  },
  [types.MUTATE_ROLE_PROMOTION_SEARCH_RESULT]: (state, payload) => {
    state.rolePromotionSearchResult = payload;
  },
  [types.MUTATE_ROLE_PROMOTION_STATUS_TYPES]: (state, payload) => {
    state.rolePromotionStatusTypes = payload;
  },
  [types.MUTATE_PNS_PENDING_ONBOARDING]: (state, payload) => {
    state.pns_pending_onboarding = payload;
  },
};
